import { hasRole } from '@/utils/permission'

/**
 * 角色校验指令
 * @author Ych Tu
 */
function checkRole(el: HTMLElement, binding: any) {
  const { value } = binding

  const parent = el.parentNode

  if (!parent) {
    return
  }

  if (!hasRole(value)) {
    if (parent.contains(el)) {
      parent.removeChild(el)
    }
  }
}

export default {
  mounted(el: HTMLElement, binding: any) {
    checkRole(el, binding)
  },
  updated(el: HTMLElement, binding: any) {
    checkRole(el, binding)
  }
}
